import React from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedDate from "pages/_components/FormattedDate";

const DownloadItem = ({ download, isDesktop, formId, downloadAction }) => {

    const options = [
        {
            text: `${formId}.downloadfile`,
            textType: "I18N",
            func: () => downloadAction(),
        },
    ];

    return (
        <>
            <GridTable.Data columnStart={1} columnWidth={1} rowStart={1}>
                {isDesktop ? (
                    <CustomText text={<FormattedDate
                        date={download.date} dateFormat="DD/MM/YYYY"
                    />} />
                ) : (
                    <CustomData
                        titleText={`${formId}.date`}
                        titleTextType="I18N"
                        valueText={<FormattedDate
                        date={download.date} dateFormat="DD/MM/YYYY"
                    />}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 2 : 1} columnWidth={1} rowStart={isDesktop ? 1 : 2}>
                {isDesktop ? (
                    <CustomText text={download.nameToShow} />
                ) : (
                    <CustomData
                        titleText={`${formId}.name`}
                        titleTextType="I18N"
                        valueText={download.nameToShow}
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 3 : 2}
                columnWidth={1}
                rowStart={1}
                alignY="center"
                className="adhered-services-button">
                <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
            </GridTable.Data>
        </>
    );
};

DownloadItem.propTypes = {
    receivedAdheredService: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
};

export default DownloadItem;